var React = require('react');

function SeparatorVerticalInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.91725 268.505C2.91725 266.517 0.874541 264.581 1.0061 246.978C1.38291 196.56 4.10718 26.8286 2.91722 18.5554C1.32596 7.49223 2.91722 2.21882 2.91722 0.999674","stroke":"#169495","strokeWidth":"2","strokeLinecap":"round"}));
}

SeparatorVerticalInline.defaultProps = {"width":"5","height":"270","viewBox":"0 0 5 270","fill":"none"};

module.exports = SeparatorVerticalInline;

SeparatorVerticalInline.default = SeparatorVerticalInline;
